const aspectRatioKeeperClasses = {
  "1:1": "1/1",
  "5:4": "5/4",
  "4:5": "4/5",
  "4:3": "4/3",
  "3:4": "3/4",
  "3:2": "3/2",
  "2:3": "2/3",
  "16:10": "16/10",
  "10:16": "10/16",
  "Golden ratio": "1.618/1",
  "Golden ratio Portrait": "1/1.618",
  "16:9": "16/9",
  "9:16": "9/16",
  "2:1": "2/1",
  "1:2": "1/2",
  "21:9": "21/9",
  "9:21": "9/21",
  A4: "297/210",
  "A4 Portrait": "210/297",
  Letter: "11/8.5",
  "Letter Portrait": "8.5/11",
  "32:9": "32/9",
  none: "unset"
};

export { aspectRatioKeeperClasses };
